import React from "react";
import { formatPrice } from "../../../../../../../../common-deprecated/Globalize";
import Icon, { IconExclamation } from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import {
    type BuildAndBuyLabelType,
    bnbIntegratedTradeInNotificationsLabels,
    BnbLabel,
} from "../../../../../utils/labels";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../../redux/store";
import * as PanelStyles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/BasketPanel";
import * as Styles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/BasketPanelDetails";
import { IconWrapper } from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { showModal } from "../../../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_INTEGRATED_TRADE_IN_AEM } from "../../../../../../../../shared-logic/features/tradein/utils/integratedModalConstants";
import {
    clearTradeInAemExtData,
    setTradeInNotification,
} from "../../../../../../../../common-deprecated/features/tradein/redux/actions/TradeInAemExternalDataActions";
import { showPrice } from "../../../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";
import { trackCtaCalculator } from "../../../../../utils/tracking";
import ButtonCta, { CtaIcon } from "../../../../../../../../common-deprecated/components/aem/toyota/ButtonCta";
import { useDispatch } from "../../../../../../../../shared-logic/redux/store";

/**
 * TODO OR-8912 - Align notifications
 */
const TradeInDetails = (): JSX.Element | null => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const notification = useBnbSelector(
        (state) => state.tradeInAemExternalData.notification[state.utils.financeOption],
    );
    const { vehicleName, vehicleValue, licensePlate, vin } = useBnbSelector(
        (state) => state.tradeInAemExternalData.data,
    );
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const step = useBnbSelector((state) => state.navigation.step);

    const vehicleTitle = vehicleName ? `${vehicleName.name} ${vehicleName?.description || ""}` : "";
    const vehiclePlate = licensePlate || vin || "";

    const showContent = !!vehicleTitle && !!vehicleValue && !notification.isError;

    // Some labels here are from tradein settings as this component is only shown when integrated tradein is active.
    // Because of this it is easier to just cast it for now
    const showNotification = notification.notificationType && notification.show;

    const tooHighLabel: BuildAndBuyLabelType =
        financeOption === "cash" ? "tradeinBasketTooHighCash" : "tradeinBasketTooHighMonthly";

    const formattedPrice = formatPrice(vehicleValue || 0, commonSettings.culture.name).replace(" ", "&nbsp;");
    const showPrices = showPrice(commonSettings);

    if (!showPrices) return null;

    return (
        <>
            <Styles.TradeInNotificationWrapper show={!!showNotification}>
                <Styles.TradeInNotification show={!!showNotification}>
                    <Styles.TradeInNotificationClose
                        onClick={() => {
                            dispatch(setTradeInNotification(financeOption, false));
                        }}
                    >
                        <Icon variant="close" />
                    </Styles.TradeInNotificationClose>

                    <Styles.TradeInNotificationIcon positive={!notification.isError}>
                        <Icon variant={notification.isError ? "close" : "check"} />
                    </Styles.TradeInNotificationIcon>

                    <Styles.TradeInNotificationTitle mt={3}>
                        <BnbLabel label={"tradeinBasketUpdate" as any} />
                    </Styles.TradeInNotificationTitle>
                    <Type.SmallText mt={2} mb={2}>
                        {notification.notificationType && (
                            <BnbLabel label={bnbIntegratedTradeInNotificationsLabels[notification.notificationType]} />
                        )}
                    </Type.SmallText>
                </Styles.TradeInNotification>
            </Styles.TradeInNotificationWrapper>

            {showContent && !showNotification && (
                <PanelStyles.Panel>
                    <Styles.TradeInHeader>
                        <Styles.TradeInTitle>
                            {notification.isError && (
                                <PanelStyles.PanelIconWrapper>
                                    <IconExclamation />
                                </PanelStyles.PanelIconWrapper>
                            )}
                            <BnbLabel label="partExchangeTitle" />
                        </Styles.TradeInTitle>
                    </Styles.TradeInHeader>

                    <Styles.TradeInBody>
                        <Styles.TradeInLabel>
                            {notification.isError ? (
                                <BnbLabel label={tooHighLabel} />
                            ) : (
                                <span>
                                    {vehicleTitle}
                                    {vehiclePlate && (
                                        <>
                                            <br />
                                            {vehiclePlate}
                                        </>
                                    )}
                                </span>
                            )}
                        </Styles.TradeInLabel>

                        <Styles.TradeInValue>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: `${financeOption === "cash" ? "- " : ""}${formattedPrice}`,
                                }}
                            />
                            <IconWrapper
                                onClick={(event) => {
                                    event.preventDefault();
                                    dispatch(clearTradeInAemExtData());
                                }}
                            >
                                <Icon variant="close" />
                            </IconWrapper>
                        </Styles.TradeInValue>
                    </Styles.TradeInBody>
                </PanelStyles.Panel>
            )}

            <ButtonCta
                onClick={() => {
                    trackCtaCalculator(step, "tradein-calculator");
                    dispatch(showModal({ type: MODAL_INTEGRATED_TRADE_IN_AEM }));
                }}
                iconVariant={CtaIcon.CarExchange}
            >
                <BnbLabel label={vehicleName ? "editPartExchange" : "partExchange"} />
            </ButtonCta>
        </>
    );
};

export default TradeInDetails;
